module.exports = __webpack_public_path__ + "img/facebook.29513c40.png";